export default "__VITE_ASSET__DhKnjlSX__"